import type { AIDTColor } from './_typing';

export const mint: AIDTColor = Object.freeze({
  50: '#e0f7fa',
  100: '#DAF0F2',
  200: '#B5E0E5',
  300: '#91D1D9', // science elementary key
  400: '#6CC1CC',
  500: '#47B2BF', // science middle key
  600: '#359AA8',
  700: '#248192',
  800: '#12697B',
  900: '#005064', // science high bg
  950: '#003543',
  0: '#001B21', // science high key
} as const);
